<script setup lang="ts">
export interface Props {
  filters?: PlannedDeliveryFilters
}

const { filters } = defineProps<Props>()
const value = defineModel<PlannedDeliveryTab>()
const router = useRouter()

const { data: counts } = usePlannedDeliveriesCount({ filters: () => filters })

const tab = computed<PlannedDeliveryTab>({
  get: () => value.value,
  set: (val: PlannedDeliveryTab) => {
    value.value = val

    if (val === 'failed')
      router.replace(`/planned-deliveries/failures`)
    else {
      router.replace(`/planned-deliveries`)
    }
  },
})
</script>

<template>
  <KernelSlider
    v-model="tab"
    class="fill"
  >
    <KernelSliderItem id="toCheck">
      <KernelBadge color="signal-orange">
        {{ counts.toCheck }}
      </KernelBadge>

      {{ $t('plannedDeliveries.toCheck') }}
    </KernelSliderItem>
    <KernelSliderItem id="checkAgain">
      <KernelBadge color="signal-yellow">
        {{ counts.checkAgain }}
      </KernelBadge>

      {{ $t('plannedDeliveries.checkAgain') }}
    </KernelSliderItem>
    <KernelSliderItem id="checked">
      <KernelBadge color="signal-blue-default">
        {{ counts.checked }}
      </KernelBadge>

      {{ $t('plannedDeliveries.checked') }}
    </KernelSliderItem>
    <KernelSliderItem id="readyToPrescribe">
      <KernelBadge color="signal-green-default">
        {{ counts.readyToPrescribe }}
      </KernelBadge>

      {{ $t('plannedDeliveries.readyToPrescribe') }}
    </KernelSliderItem>
    <KernelSliderItem id="prescribed">
      <KernelBadge color="brand-aubergine-default">
        {{ counts.prescribed }}
      </KernelBadge>

      {{ $t('plannedDeliveries.prescribed') }}
    </KernelSliderItem>
    <KernelSliderItem id="shipped">
      <KernelBadge color="brand-lavender-default">
        {{ counts.shipped }}
      </KernelBadge>

      {{ $t('plannedDeliveries.shipped') }}
    </KernelSliderItem>
    <KernelSliderItem id="failed">
      <KernelBadge color="brand-coral-default">
        {{ counts.failed }}
      </KernelBadge>

      {{ $t('plannedDeliveries.failed') }}
    </KernelSliderItem>
  </KernelSlider>
</template>
